// ── 매입 표 줄 입력·색 공용 도우미 (2026-11-03 노션처럼 표에서 바로 쓰기) ─────────────
// 날짜는 input 값 문자열 그대로 보낸다(new Date 변환 없음). 금액은 음수도 있어 글자 칸(콤마는 서버가 다듬음).

export const KIND_OPTIONS = ['카드', '입금'];

export const COLS = [
  { key: 'kind',                    label: '구분',       width: 80,  type: 'kind' }, // 고칠 때 '카드' 고르기가 다 보이게
  { key: 'use_date',                label: '사용일',     width: 110, type: 'date' },
  { key: 'vendor',                  label: '업체',       width: 200 },
  { key: 'amount',                  label: '금액',       width: 120, align: 'right', type: 'money' },
  { key: 'note',                    label: '비고',       width: 260, wrap: true },
  { key: 'note2',                   label: '비고2',      width: 160, wrap: true },
  { key: 'tax_invoice_amount',      label: '세금계산서', width: 110, align: 'right', type: 'money' },
  { key: 'tax_invoice_issued_date', label: '발급일',     width: 110, type: 'date' },
];

// 줄 색(color_marks.row) — 반투명이라 밝은·어두운 화면 모두 글자가 읽힌다
export const ROW_COLORS = [
  { key: 'yellow', label: '노랑', swatch: '#facc15', bg: 'rgba(250,204,21,0.20)' },
  { key: 'green',  label: '초록', swatch: '#22c55e', bg: 'rgba(34,197,94,0.17)' },
  { key: 'blue',   label: '파랑', swatch: '#3b82f6', bg: 'rgba(59,130,246,0.17)' },
  { key: 'red',    label: '빨강', swatch: '#ef4444', bg: 'rgba(239,68,68,0.16)' },
];
export const rowColorBg = (row) => ROW_COLORS.find((c) => c.key === row?.color_marks?.row)?.bg || null;

export function fmtMoney(v) {
  if (v == null || v === '') return '';
  const n = Number(String(v).replace(/,/g, ''));
  return Number.isFinite(n) ? n.toLocaleString('ko-KR') : String(v);
}

export function draftOf(row) {
  return {
    kind: row?.kind || '',
    use_date: row?.use_date || '',
    vendor: row?.vendor || '',
    amount: fmtMoney(row?.amount),
    note: row?.note || '',
    note2: row?.note2 || '',
    tax_invoice_amount: fmtMoney(row?.tax_invoice_amount),
    tax_invoice_issued_date: row?.tax_invoice_issued_date || '',
  };
}

export const isBlankDraft = (d) => COLS.every((c) => !String(d?.[c.key] ?? '').trim());

// 금액은 콤마를 빼고 비교 — '12,345' 와 12345 는 같은 값
const cmp = (c, v) => (c.type === 'money' ? String(v ?? '').replace(/[,\s]/g, '') : String(v ?? '').trim());
export const draftChanged = (row, d) => COLS.some((c) => cmp(c, draftOf(row)[c.key]) !== cmp(c, d?.[c.key]));
